'use client';

import { createElement } from 'react';
import { TagProps } from './Tag.props';

const Tag = ({ tagName: Tag = 'div', ...props }: TagProps) => {
  return createElement(Tag, props);
};

export default Tag;
